export const SHOW_SERVICE_CHOICE_MODAL = 'venue/SHOW_SERVICE_CHOICE_MODAL';
export const HIDE_SERVICE_CHOICE_MODAL = 'venue/HIDE_SERVICE_CHOICE_MODAL';
export const SET_GOOGLE_MAP_ERROR = 'venue/SET_GOOGLE_MAP_ERROR';
export const MARK_AS_SHOWN = 'venue/MARK_AS_SHOWN';
